import type { MouseEvent } from 'react';
import { ArrowLeft } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n';

/**
 * Back link and a centred title, the same on every inner screen. `onBack` may
 * call `preventDefault()` to stop the navigation (e.g. to ask about unsaved changes).
 */
export function PageHeader({
  title,
  to = '/',
  onBack,
}: {
  title: string;
  to?: string;
  onBack?: (e: MouseEvent<HTMLAnchorElement>) => void;
}) {
  const t = useT();
  return (
    <header className="flex items-center justify-between mb-4">
      <Link
        to={to}
        onClick={onBack}
        className="inline-flex items-center gap-1 text-sm text-hint active:text-fg hover:text-fg transition-colors"
      >
        <ArrowLeft size={16} />
        {t.common.back}
      </Link>
      <h1 className="text-lg font-bold">{title}</h1>
      <span className="w-12" />
    </header>
  );
}
